import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedMenuId: null,
    selectedSubcategory: null,
    selectedCard: sessionStorage.getItem("selectedCard") || null
};

const exampleSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        selectMenuItemId: (state, action) => {
            state.selectedMenuId = action.payload
            state.selectedSubcategory = "Նյութեր"
        },
        selectSubcategory: (state, action) => {
            state.selectedMenuId = action.payload?.menuId
            state.selectedSubcategory = action.payload?.subcategory || "Նյութեր"
        },
        selectCardContent: (state, action) => {
            if ( !action.payload ) {
                sessionStorage.removeItem("selectedCard");
            }
            state.selectedCard = action.payload
        }
    },
});

export const { selectMenuItemId,selectCardContent, selectSubcategory } = exampleSlice.actions;
export default exampleSlice.reducer;
